import * as TypeGraphQL from "type-graphql";
export var WaitlistStatus;
(function (WaitlistStatus) {
    WaitlistStatus["PENDING"] = "PENDING";
    WaitlistStatus["APPROVED"] = "APPROVED";
    WaitlistStatus["REJECTED"] = "REJECTED";
})(WaitlistStatus || (WaitlistStatus = {}));
TypeGraphQL.registerEnumType(WaitlistStatus, {
    name: "WaitlistStatus",
    description: undefined,
});
//# sourceMappingURL=WaitlistStatus.js.map